const globals = {
    title: 'Title custom into globals i18n',
    allRightsReserved: '',
    close: 'Close',
}

export default globals
